import { useAccordion } from "~/lib/accordion"

document.addEventListener('DOMContentLoaded', () => {
  useAccordion('.first-accordion')
})